/**
 * Sind Cookies erlaubt?
 *
 * @type {boolean}
 */
export const cookieEnabled: boolean = navigator.cookieEnabled;
export const UNTIS_URL = 'https://www.untis.at';



// WEBPACK FOOTER //
// ./src/config/index.ts